<template>
    <v-dialog max-width="1000px" v-model="open" persistent>
        <v-card>
            <v-toolbar elevation="0">
                <v-toolbar-title>{{ member.full_name}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="mt-4">
                <v-container>
                    <v-data-table class="ml-1 mr-1" :headers="headers" :items="data" mobile-breakpoint="0"></v-data-table>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import EventBus from '@/js/eventbus'
export default {
    props:{
        lang: Object,
        member: Object,
        status: Number,
        open: Boolean
    },
    data(){
        return {
            headers: [
                {text: 'Vreme', value: 'start_date', align: 'start', sortable: false},
                {text: 'Naziv', value: 'title', align: 'start', sortable: false},
                {text: 'Trener', value: 'trainer', align: 'start'}
            ],
            data: []
        }
    },
    computed: {
        
    },
    created(){
        this.getData();
    },
    methods:{

        close(){
            this.$emit('on-close');
        },

        getData() {
            this.saving = true;
            axios.get('/backoffice/members/dashboard/appointments', {params: {'member_id': this.member.id, 'status': this.status }})
                .then(response => {
                    this.data = response.data;                    
                })
                .catch(error => {
                    this.saving = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
        }
    }
}
</script>
